import { useLogout, useUser } from "@/core/user/userApplication";
import { useRouter } from "@/routes/hooks";
import { Avatar, AvatarImage, AvatarFallback } from "@/ui/avatar";
import { Button } from "@/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/ui/dropdown-menu";
import to from "await-to-js";
import { useTranslation } from "react-i18next";
import { ChevronDownIcon } from "lucide-react";

/**
 * Account Dropdown
 */
export default function AccountDropdown() {
	const { replace } = useRouter();
	const { data: user } = useUser();
	const { t } = useTranslation();
	const logoutUser = useLogout();
	if (!user) {
		return null;
	}
	const { username, email, avatar } = user;
	const handleLogout = async () => {
		const [logoutError] = await to(logoutUser());
		if (logoutError) {
			console.error("Logout failed:", logoutError);
			return;
		}
		replace("/login");
	};

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost">
					<Avatar>
						<AvatarImage src={avatar} />
						<AvatarFallback className="font-bold">{username[0]}</AvatarFallback>
					</Avatar>
					<span>{username}</span>
					<div className="ml-4">
						<ChevronDownIcon />
					</div>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="w-56">
				<div className="flex items-center gap-2 p-2">
					<Avatar>
						<AvatarImage src={avatar} />
						<AvatarFallback className="font-bold text-gray-900">
							{username[0]}
						</AvatarFallback>
					</Avatar>
					<div className="flex flex-col items-start">
						<div className="text-text-primary text-sm font-medium">
							{username}
						</div>
						<div className="text-text-secondary text-xs">{email}</div>
					</div>
				</div>
				<DropdownMenuSeparator />
				<DropdownMenuItem
					className="font-bold text-warning"
					onClick={handleLogout}
				>
					{t("sys.login.logout")}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
